import React from 'react';
export function ForWho() {
  const yesItems = ['Duermes pero no descansas', 'Tienes estrés laboral o familiar acumulado', 'Quieres entender qué le pasa a tu cuerpo', 'Prefieres protocolos medibles, no promesas', 'Eres hispano/a en USA (25–50 años)', 'Quieres más energía y claridad mental'];
  const noItems = ['Buscas pastillas o soluciones sin esfuerzo', 'Tienes apnea del sueño sin tratar', 'Tienes depresión severa sin tratamiento', 'Esperas resultados sin seguir el protocolo', 'Buscas contenido solo en inglés', 'Ya duermes perfectamente bien'];
  return <section className="w-full bg-navy py-16 md:py-24 px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-125">
          ¿ES PARA TI?
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-126">
          Este protocolo es para ti si:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-127">
          {/* Yes Column */}
          <div className="bg-navy-light rounded-xl p-6" data-id="element-128">
            <h3 className="text-cta font-bold text-lg mb-4" data-id="element-129">
              ✅ SÍ ES PARA TI
            </h3>
            <ul className="space-y-3" data-id="element-130">
              {yesItems.map((item, index) => <li key={index} className="text-white flex items-start gap-2" data-id="element-131">
                  <span className="text-cta" data-id="element-132">✅</span>
                  <span data-id="element-133">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* No Column */}
          <div className="bg-navy-light rounded-xl p-6" data-id="element-134">
            <h3 className="text-alert font-bold text-lg mb-4" data-id="element-135">
              ❌ NO ES PARA TI
            </h3>
            <ul className="space-y-3" data-id="element-136">
              {noItems.map((item, index) => <li key={index} className="text-white flex items-start gap-2" data-id="element-137">
                  <span className="text-alert" data-id="element-138">❌</span>
                  <span data-id="element-139">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}